export const ID = 'id';
export const TEXT = 'text';
export const MARK = 'mark';
